import {
  useMutateItem,
  useGetListItems,
  useMutateDeleteItem,
  useMutateItemResendUserInvite,
  useMutateItemWithUpload,
} from '../../hooks/entityMethodsHook'

export const useMutateUserAccount = (key: any) => {
  const uri = 'timecards'
  return useMutateItem(key, uri)
}

export const useGetUserAccounts = (key: any) => {
  const uri = `users/list`
  return useGetListItems(key, uri, true)
}

export const useGetUserInvitations = (key: any) => {
  const uri = `users/invitations`
  return useGetListItems(key, uri, true)
}

export const useMutateInviteUser = (key: any) => {
  const uri = 'users/invite'
  return useMutateItem(key, uri)
}

export const useMutateResendInviteUser = (key: any) => {
  const uri = 'users/invitations'
  return useMutateItemResendUserInvite(key, uri)
}

export const useMutateDeleteUserInvitation = (key: any) => {
  const uri = `users/invitations`
  return useMutateDeleteItem(key, uri)
}

export const useGetUserAccount = (key: any, userId: string | undefined) => {
  const uri = `users/${userId}`
  return useGetListItems(key, uri, true)
}

export const useMutateUser = (key: any) => {
  const uri = 'users'
  return useMutateItemWithUpload(key, uri)
}

export const useMutateDeleteUser = (key: any) => {
  const uri = `users`
  return useMutateDeleteItem(key, uri)
}
